import { EXTENSION_FRAME_ID } from '@shared/extension/constants';
import { AppAction, BackgroundAction, ContentScriptAction } from '@shared/extension/enums';
import { addAppWindowEventListener, dispatchAppWindowEvent, safeSendChromeRuntimeMessage } from '@shared/extension/utils/events';
import { withChromeRuntime } from '@shared/extension/utils/runtime';

export function startHandlingAppActions(): void {
  addAppWindowEventListener(ContentScriptAction.GetLocalStorage, (event) => {
    const detail = (event as CustomEvent).detail;
    withChromeRuntime(() => {
      safeSendChromeRuntimeMessage({ action: BackgroundAction.GetLocalStorage, detail }, (response) => {
        const responseEvent = new CustomEvent(
          AppAction.GetLocalStorageResponse,
          { detail: response }
        );
        dispatchAppWindowEvent(responseEvent);
      });
    });
  });

  addAppWindowEventListener(ContentScriptAction.GetProfileEmail, () => {
    withChromeRuntime(() => {
      safeSendChromeRuntimeMessage({ action: BackgroundAction.GetProfileEmail }, (response) => {
        const responseEvent = new CustomEvent(
          AppAction.GetProfileEmailResponse,
          { detail: response }
        );
        dispatchAppWindowEvent(responseEvent);
      });
    });
  });

  addAppWindowEventListener(ContentScriptAction.GetUserDetails, () => {
    withChromeRuntime(() => {
      safeSendChromeRuntimeMessage({ action: BackgroundAction.GetUserDetails }, (response) => {
        const responseEvent = new CustomEvent(
          AppAction.GetUserDetailsResponse,
          { detail: response }
        );
        dispatchAppWindowEvent(responseEvent);
      });
    });
  });

  addAppWindowEventListener(ContentScriptAction.SetLocalStorage, (event) => {
    const detail = (event as CustomEvent).detail;
    withChromeRuntime(() => {
      safeSendChromeRuntimeMessage({ action: BackgroundAction.SetLocalStorage, detail }, (response) => {
        const responseEvent = new CustomEvent(
          AppAction.SetLocalStorageResponse,
          { detail: response }
        );
        dispatchAppWindowEvent(responseEvent);
      });
    });
  });

  addAppWindowEventListener(ContentScriptAction.ViewChanged, async (event) => {
    const detail = (event as CustomEvent).detail;
    const iframe = document.getElementById(EXTENSION_FRAME_ID) as HTMLIFrameElement;
    if (typeof detail.showOverlay === 'boolean') {
      if (detail.showOverlay) {
        iframe.style.backgroundColor = '#00000036';
      } else {
        iframe.style.backgroundColor = 'transparent';
      }
    }
    iframe.style.display = detail.currentView === null? 'none' : 'block';
  });
}
